module.exports = __webpack_public_path__ + "img/amx-15.5eec005c.webp";